<template>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex lg12>
        <v-card class="statics-filters">
          <v-card-text class="row pt-1">
            <v-flex class="row pt-0">
              <v-layout xs12 md12>
                <v-flex md2>
                  <v-text-field
                    label="Fecha de corte"
                    :clearable="true"
                    v-model="filters.FechaCorte"
                    type="date"
                  ></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-spacer></v-spacer>
                  <v-flex>
                    <v-btn
                      color="default"
                      small
                      @click="search()"
                      title="Buscar"
                    >
                      Filtrar
                    </v-btn>
                    <v-btn
                      color="default"
                      small
                      @click="limpiar()"
                      title="Limpiar"
                    >
                      Limpiar
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
        </v-flex>
    <v-divider style="margin:0px"></v-divider>
    <v-flex lg12>
        <v-card>
          <v-card-text class="row pt-1">
            <preliquidation-query-list
              :items="commissionsPreliquidationQuery"
            ></preliquidation-query-list>    
          </v-card-text>
        </v-card>
      </v-flex>
    
      </v-layout>
    </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import PreliquidationQueryList from "./PreliquidationQueryList";

export default {
  computed: {
    ...mapGetters(["loadingCommission", "commissionsPreliquidationQuery", "agency",
      "estados",
      "fuentes",]),
  },
  mounted() {
    this.$store.dispatch("estados");
    this.$store.dispatch("fuentes");
    this.$store.dispatch("getCommissionsPreliquidationQuery", this.filters);
    /*     for(let i=0;i<=this.commissionsLiquidation.length; i++)
     {
       this.selectRow.push(this.commissionsLiquidation[i]);       
     } */
  },
  methods: {
    nzDate: nzDate,
    uniqueCheck(e, index) {
      for (let i = 0; i < this.selectRow.length; i++) {
        if (index != i) {
          this.selectRow[i] = false;
        }
      }
      if (!this.selectRow[index]) {
        this.selectedValue = null;
      } else {
        this.selectedValue = e;
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "creationDate") {
          let dateA = new Date(this.getDate(a[index]));
          let dateB = new Date(this.getDate(b[index]));
          /* let demoInvalidDate=new Date(a[index])
            if(demoInvalidDate=='Invalid Date'){
              var formattedA = moment(a[index]).format('D MMMM YYYY');
              //var formattedB = moment(demoInvalidDate).format('D MMMM YYYY');
              console.log(a[index],formattedA)
           
            } */
          if (!isDesc) {
            return dateA < dateB ? -1 : 1;
          } else {
            return dateB < dateA ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDate(d) {
      var day, month, year;

      let result = String(d).match("[0-9]{2}([-/ .])[0-9]{2}[-/ .][0-9]{4}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[0];
        month = dateSplitted[1];
        year = dateSplitted[2];
      }
      result = String(d).match("[0-9]{4}([-/ .])[0-9]{2}[-/ .][0-9]{2}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[2];
        month = dateSplitted[1];
        year = dateSplitted[0];
      }

      if (month > 12) {
        let aux = day;
        day = month;
        month = aux;
      }

      return year + "/" + month + "/" + day;
    },
    changeSort(column) {
      this.selectedValue = null;
      (this.selectRow = []), (this.additional_grouped = []);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additional_grouped[0] = this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additional_grouped[0] = this.selectedValue;
      }
      // console.log(this.pagination.sortBy)
    },
    refresh() {
      this.getPreliquidationQuery();
    },
    getPreliquidationQuery() {
      this.$store.dispatch("getCommissionsPreliquidationQuery", this.filters);
    },
    search() {
      this.$store.dispatch("getCommissionsPreliquidationQuery", this.filters);
    },
    limpiar() {
      this.filters = {
        apsCode: "1016",
        IdAgencia: "0",
        ApsUser: "USER_CF",
        Moneda: "1",
        FechaCorte: new Date()
      };
      this.$store.dispatch("getCommissionsPreliquidationQuery", this.filters);
    },
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getCommissionsPreliquidationQuery", this.filters);
    },
  },
  components: {
    PreliquidationQueryList,
  },
  data() {
    return {
      selectedValue: null,
      selectRow: [],
      additional_grouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "creationDate",
      },
      selected: [],
      filters: {
        apsCode: "",
        IdAgencia: "0",
        ApsUser: "USER_CF",
        Moneda: "1",
        FechaCorte: new Date()
      },
    };
  },
};
</script>
